import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const InventairePage: FC = () => {  
    return (
        <Outlet />
    );
}

export default InventairePage